import './App.css';
import Home from './Components/Home';
import DetailPage from './Components/DetailPage';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Genre from './Components/Genre';
import Trending from './Components/Trending';
import Search from './Components/Search';
import History from './Components/History'; // Import History
import Reader from './Components/Reader';
import Author from './Components/Author';
import Genres from './Components/Genres';
import Favorites from './Components/Favorites';
import ScrollToTop from './Components/UI/ScrollToTop';
import { ThemeProvider } from './contexts/ThemeContext';
import { ReadingPreferencesProvider } from './contexts/ReadingPreferencesContext';

function App() {
  return (
    <ThemeProvider>
      <ReadingPreferencesProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/comics/:slug" element={<DetailPage />} />
        <Route path="/genre/:slug" element={<Genre />} />
        <Route path="/trending/:slug" element={<Trending />} />
        <Route path="/search" element={<Search />} />
        <Route path="/history" element={<History />} />
        <Route path="/read" element={<Reader />} />
        <Route path="/read/:slug/:cid" element={<Reader />} />
        <Route path="/author/:slug" element={<Author />} />
        <Route path="/genres" element={<Genres />} />
        <Route path="/favorites" element={<Favorites />} />
          </Routes>
        </BrowserRouter>
      </ReadingPreferencesProvider>
    </ThemeProvider>
  );
}

export default App;